// extracted by mini-css-extract-plugin
export default {"details":"Details_details__4ClmQ","opened":"Details_opened__i9k0X","container":"Details_container__iQsf+","card":"Details_card__HiHuS","shimmer":"Details_shimmer__waUMc"};